import React, { useEffect, useState } from 'react';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import {
  Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent,
  BlockTitle, Button, Col, DataTable, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent
} from '../../../components/Component';
import {
  Badge, Card, Input, UncontrolledDropdown, DropdownMenu,
  DropdownToggle, DropdownItem, Table
} from 'reactstrap';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import {
  fail_retrieve_products, loading_retrieve_products,
  reset_retrieve_products, success_retrieve_products
} from '../../../reducers/auth_tenant/retrieve_products_Slice';
import {
  ADD_PRODUCT_ERROR_MSG, ADD_PRODUCT_SUCCESS_MSG,
  RETIREVE_PRODUCT_ERROR_MSG, RETIREVE_PRODUCT_SUCCESS_MSG,
  UPDATE_PRODUCT_VIEWABLE_ON_WEBSITE_ERROR_MSG,
  UPDATE_PRODUCT_VIEWABLE_ON_WEBSITE_SUCCESS_MSG
} from '../../../utils/error_success_messages';
import { RETRIEVE_TENANT_PRODUCTS_API, TENANT_TOGGLE_PRODUCT_VIEWABLE_ON_WEBSTORE_API } from '../../../api/api_data';
import * as app_consts from "../../../utils/app_consts";
import { useSelector } from 'react-redux';
import { addThreeDots, joinWithCommas, messageToast } from '../../../utils/Utils';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import AddProductModal from '../../../components/modal/AddProductModal';
import { fail_update_product_viewable_on_webstore, loading_update_product_viewable_on_webstore, reset_update_product_viewable_on_webstore, success_update_product_viewable_on_webstore } from '../../../reducers/auth_tenant/update_product_viewable_on_webstore_Slice';

const ProductManagement = ({ tenant_info, user_info }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState();
  const [current_page_data, setCurrentPageData] = useState([]);
  const [sm, updateSm] = useState(false);
  const [currentPage, setCurrentPage] = useState(() => {
    // Get saved page from localStorage or default to 1
    const savedPage = localStorage.getItem('productManagementCurrentPage');
    return savedPage ? parseInt(savedPage) : 1;
  });
  const [itemPerPage] = useState(5); // Show 5 categories per page
  const [add_product_modal, setAddProductModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState(() => {
    // Get saved search term from localStorage
    return localStorage.getItem('productManagementSearchTerm') || "";
  });
  const [categoryFilter, setCategoryFilter] = useState(() => {
    // Get saved category filter from localStorage
    return localStorage.getItem('productManagementCategoryFilter') || "All";
  });
  const [statusFilter, setStatusFilter] = useState(() => {
    // Get saved status filter from localStorage
    return localStorage.getItem('productManagementStatusFilter') || "All";
  });
  const [viewable_on_webstore_loading, setViewableOnWebstoreLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    // Save state to localStorage whenever it changes
    localStorage.setItem('productManagementCurrentPage', currentPage);
    localStorage.setItem('productManagementSearchTerm', searchTerm);
    localStorage.setItem('productManagementCategoryFilter', categoryFilter);
    localStorage.setItem('productManagementStatusFilter', statusFilter);
  }, [currentPage, searchTerm, categoryFilter, statusFilter]);

  useEffect(() => {
    retrieve_products();

    // Set up beforeunload event to handle page refresh
    const handleBeforeUnload = () => {
      localStorage.setItem('productManagementScrollPosition', window.scrollY);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Restore scroll position if available
    const savedScrollPosition = localStorage.getItem('productManagementScrollPosition');
    if (savedScrollPosition)
    {
      window.scrollTo(0, parseInt(savedScrollPosition));
      localStorage.removeItem('productManagementScrollPosition');
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const retrieve_products = () => {
    setError("");
    setLoading(true);
    dispatch(tenant_auth_actions_helper(
      loading_retrieve_products,
      success_retrieve_products,
      fail_retrieve_products,
      RETIREVE_PRODUCT_ERROR_MSG,
      RETIREVE_PRODUCT_SUCCESS_MSG,
      app_consts.GET,
      `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_PRODUCTS_API}`
    ));
  };

  const retrieve_products_listener = useSelector((state) => state.retrieve_products.retrieve_products);

  useEffect(() => {
    if (retrieve_products_listener.status !== app_consts.IDLE)
    {
      if (retrieve_products_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_products_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_products_listener.message);
          messageToast(retrieve_products_listener.message, app_consts.FAIL);
        } else if (retrieve_products_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_products_listener.data);
          setCurrentPageData(retrieve_products_listener.data);
          setTimeout(() => setLoading(false), 1000);
        }
        dispatch(reset_retrieve_products());
      }
    }
  }, [retrieve_products_listener]);

  // Group products by category with filtering and sorting
  const groupProductsByCategory = (products) => {
    if (!products) return [];

    // Apply filters
    let filtered = [...products];

    if (categoryFilter !== "All")
    {
      filtered = filtered.filter(item =>
        categoryFilter === "Uncategorized"
          ? !item.category
          : item.category === categoryFilter
      );
    }

    if (statusFilter !== "All")
    {
      filtered = filtered.filter(item => item.status === statusFilter.toLowerCase());
    }

    if (searchTerm)
    {
      filtered = filtered.filter(item => {
        const searchStr = [
          item?.category,
          item.name,
          item.product_type,
          item.sku_no,
          ...(item.packet_sizes || []),
          item.status?.replace(/_/g, ' ').toUpperCase(),
        ].join(" ").toLowerCase();

        return searchStr.includes(searchTerm.toLowerCase());
      });
    }

    const grouped = filtered.reduce((acc, product) => {
      const category = product.category || 'Uncategorized';
      if (!acc[category])
      {
        acc[category] = [];
      }
      acc[category].push(product);
      return acc;
    }, {});

    return Object.entries(grouped)
      .map(([category, items]) => ({
        category,
        items: items.sort((a, b) => a.name.localeCompare(b.name)), // Sort products alphabetically by name
        count: items.length
      }))
      .sort((a, b) => a.category.localeCompare(b.category)); // Sort categories alphabetically
  };

  // Get all unique categories for filter dropdown
  const getUniqueCategories = (products) => {
    if (!products) return [];
    const categories = new Set(products.map(p => p.category || 'Uncategorized'));
    return ['All', ...Array.from(categories).sort()];
  };

  const groupedProducts = groupProductsByCategory(current_page_data);
  const uniqueCategories = getUniqueCategories(current_page_data);

  // Pagination for categories
  const indexOfLastCategory = currentPage * itemPerPage;
  const indexOfFirstCategory = indexOfLastCategory - itemPerPage;
  const currentCategories = groupedProducts.slice(indexOfFirstCategory, indexOfLastCategory);
  const totalCategories = groupedProducts.length;

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // Scroll to top when changing pages
  };

  const toggle_add_product = () => {
    setAddProductModal(!add_product_modal);
  };

  const handleViewAbleOnWebstoreClick = (product_id) => {
    dispatch(tenant_auth_actions_helper(
      loading_update_product_viewable_on_webstore,
      success_update_product_viewable_on_webstore,
      fail_update_product_viewable_on_webstore,
      UPDATE_PRODUCT_VIEWABLE_ON_WEBSITE_ERROR_MSG,
      UPDATE_PRODUCT_VIEWABLE_ON_WEBSITE_SUCCESS_MSG,
      app_consts.GET,
      `/${tenant_info?.url_prefix}/${TENANT_TOGGLE_PRODUCT_VIEWABLE_ON_WEBSTORE_API}/${product_id}`
    ));
  };

  const update_product_viewable_on_webstore_listener = useSelector((state) => state.update_product_viewable_on_webstore.update_product_viewable_on_webstore);

  useEffect(() => {
    if (update_product_viewable_on_webstore_listener.status !== app_consts.IDLE)
    {
      if (update_product_viewable_on_webstore_listener.status === app_consts.LOADING)
      {
        setViewableOnWebstoreLoading(true);
      } else
      {
        setViewableOnWebstoreLoading(false);
        if (update_product_viewable_on_webstore_listener.status === app_consts.FAIL)
        {
          messageToast(update_product_viewable_on_webstore_listener.message, app_consts.FAIL);
        } else if (update_product_viewable_on_webstore_listener.status === app_consts.SUCCESS)
        {
          // Remap Data to make Change Effect
          const updated_page_data = page_data?.map(item => item.id === update_product_viewable_on_webstore_listener.data?.id ? { ...item, viewable_on_webstore: update_product_viewable_on_webstore_listener.data?.viewable_on_webstore } : item);
          const updated_current_page_data = current_page_data?.map(item => item.id === update_product_viewable_on_webstore_listener.data?.id ? { ...item, viewable_on_webstore: update_product_viewable_on_webstore_listener.data?.viewable_on_webstore } : item);

          setPageData(updated_page_data);
          setCurrentPageData(updated_current_page_data);
          messageToast(UPDATE_PRODUCT_VIEWABLE_ON_WEBSITE_SUCCESS_MSG, app_consts.SUCCESS);
        }
        dispatch(reset_update_product_viewable_on_webstore());
      }
    }
  }, [update_product_viewable_on_webstore_listener]);

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Product List` : "Product List"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Products</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && current_page_data?.length > 0 && `Total Products ${current_page_data?.length}`}</p>
              </BlockDes>
              {!loading && (
                <div className="mt-2">
                  <Button
                    color="light"
                    outline
                    className="bg-white d-none d-sm-inline-flex"
                    onClick={retrieve_products}
                  >
                    <span>Refresh List</span>
                  </Button>
                </div>
              )}
            </BlockHeadContent>
            {!(loading || error) && (
              <BlockHeadContent>
                <div className="toggle-wrap nk-block-tools-toggle">
                  <a
                    href="#more"
                    className="btn btn-icon btn-trigger toggle-expand me-n1"
                    onClick={(ev) => {
                      ev.preventDefault();
                      updateSm(!sm);
                    }}
                  >
                    <Icon name="more-v"></Icon>
                  </a>
                  <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                    <ul className="nk-block-tools g-3">
                      <li>
                        <div className="form-control-wrap">
                          <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div>
                          <Input
                            type="text"
                            className="form-control"
                            id="default-04"
                            value={searchTerm}
                            onChange={e => {
                              setSearchTerm(e.target.value);
                              setCurrentPage(1);
                            }}
                            placeholder="Search products..."
                          />
                        </div>
                      </li>
                      <li>
                        <UncontrolledDropdown>
                          <DropdownToggle color="light" outline className="bg-white dropdown-toggle">
                            {categoryFilter === "All" ? "All Categories" : categoryFilter}
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem onClick={() => setCategoryFilter("All")}>All Categories</DropdownItem>
                            {uniqueCategories.filter(c => c !== "All").map(category => (
                              <DropdownItem
                                key={category}
                                onClick={() => {
                                  setCategoryFilter(category);
                                  setCurrentPage(1);
                                }}
                              >
                                {category}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </li>
                      <li>
                        <UncontrolledDropdown>
                          <DropdownToggle color="light" outline className="bg-white dropdown-toggle">
                            {statusFilter === "All" ? "All Status" : statusFilter}
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem onClick={() => setStatusFilter("All")}>All Status</DropdownItem>
                            <DropdownItem onClick={() => setStatusFilter("Active")}>Active</DropdownItem>
                            <DropdownItem onClick={() => setStatusFilter("Inactive")}>Inactive</DropdownItem>
                            <DropdownItem onClick={() => setStatusFilter("Archive")}>Archive</DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </li>
                      {(user_info?.roles?.includes(app_consts.ADD_PRODUCT) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                        <li className="nk-block-tools-opt">
                          <Button
                            className="toggle d-none d-md-inline-flex"
                            color="primary"
                            onClick={toggle_add_product}
                          >
                            <Icon name="plus"></Icon>
                            <span>Add Product</span>
                          </Button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </BlockHeadContent>
            )}
          </BlockBetween>
        </BlockHead>

        <Block>
          {loading ? (
            <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Products..." />
          ) : error ? (
            <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
          ) : page_data && page_data?.length > 0 ? (
            <>
              {currentCategories.length > 0 ? (
                currentCategories.map((group) => (
                  <div key={group.category} className="mb-4">
                    <div className="d-flex flex-column mb-3">
                      <h5 className="title" style={{ fontWeight: '600', color: '#2c3e50' }}>
                        {group.category}
                      </h5>
                      <div>
                        <Badge color="primary" className="w-auto badge-dim">
                          {group.count} {group.count === 1 ? 'product' : 'products'}
                        </Badge>
                      </div>
                    </div>

                    <Block>
                      <div className="nk-tb-list is-separate is-medium mb-3">
                        <DataTableHead className="nk-tb-item">
                          <DataTableRow>
                            <span className="sub-text">Brand</span>
                          </DataTableRow>
                          <DataTableRow>
                            <span className="sub-text">Name</span>
                          </DataTableRow>
                          <DataTableRow>
                            <span className="sub-text">Type</span>
                          </DataTableRow>
                          <DataTableRow>
                            <span className="sub-text">SKU No</span>
                          </DataTableRow>
                          <DataTableRow>
                            <span className="sub-text">Stock</span>
                          </DataTableRow>
                          <DataTableRow>
                            <span className="sub-text">Unit Value</span>
                          </DataTableRow>
                          <DataTableRow>
                            <span className="sub-text">Sizes</span>
                          </DataTableRow>
                          <DataTableRow>
                            <span className="sub-text">Viewable On Webstore</span>
                          </DataTableRow>
                          <DataTableRow>
                            <span className="sub-text">Status</span>
                          </DataTableRow>
                          <DataTableRow>
                            <span className="sub-text">Action</span>
                          </DataTableRow>
                        </DataTableHead>
                        {group?.items.map((item, idx) => (
                          <DataTableItem key={item?.id} className="tb-tnx-item">
                            <DataTableRow size="sm">
                              <Link to={`/${tenant_info.url_prefix}/products_management/${item?.id}`}>
                                <span className="tb-product">
                                  <span className="title">{item?.category || "--"}</span>
                                </span>
                              </Link>
                            </DataTableRow>
                            <DataTableRow>
                              <span className="tb-product">
                                <div className="me-3" style={{ width: '60px', height: '60px' }}>
                                  <img
                                    src={item?.product_img}
                                    alt={item?.name}
                                    className="img-thumbnail rounded"
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                      backgroundColor: '#f8f9fa'
                                    }}
                                  />
                                </div>
                                <span className="tb-sub">{item?.name || "--"}</span>
                              </span>
                            </DataTableRow>
                            <DataTableRow>
                              <span className="tb-sub">{item?.product_type || "--"}</span>
                            </DataTableRow>
                            <DataTableRow>
                              <span className="tb-sub">{item?.sku_no || "--"}</span>
                            </DataTableRow>
                            <DataTableRow>
                              <div className="user-card">
                                <div className="user-info">
                                  <span className="tb-lead">
                                    {item?.total_stock || "0"}
                                  </span>
                                  <span>RESERVED | {item?.reserved_stock ? item?.reserved_stock : "0"}</span>
                                </div>
                              </div>
                              <span className="tb-sub"></span>

                            </DataTableRow>
                            <DataTableRow>
                              <span className="tb-sub">{item?.product_value ? `${parseFloat(item?.product_value).toFixed(2)} ZMW` : "--"}</span>
                            </DataTableRow>
                            <DataTableRow size="md">
                              <span className="tb-sub">
                                {item?.packet_sizes ? addThreeDots(joinWithCommas(item?.packet_sizes), 30) : "--"}
                              </span>
                            </DataTableRow>
                            <DataTableRow>
                              <Col md="3" sm="6">
                                <div className="preview-block">
                                  <div className="custom-control custom-switch">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      checked={item?.viewable_on_webstore}
                                      id={item?.id}
                                      onClick={() => handleViewAbleOnWebstoreClick(item?.id)}
                                      disabled={!(user_info?.roles?.includes(app_consts.TOGGLE_PRODUCT_VIEWABLE_ON_WEBSTORE) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) || viewable_on_webstore_loading}
                                    />
                                    <label className="custom-control-label" htmlFor={item?.id}>

                                    </label>
                                  </div>
                                </div>
                              </Col>
                            </DataTableRow>
                            <DataTableRow size="md">
                              <span className="tb-odr-status">
                                <Badge
                                  color={
                                    item?.status === app_consts.ACTIVE
                                      ? "success"
                                      : "danger"
                                  }
                                  className="badge-dot"
                                >
                                  {item?.status?.toUpperCase() || "--"}
                                </Badge>
                              </span>
                            </DataTableRow>
                            <DataTableRow className="nk-tb-col-tools">
                              <div className="tb-odr-btns d-none d-sm-inline">
                                <Link to={`/${tenant_info.url_prefix}/products_management/${item?.id}`}>
                                  <Button color="primary" size="sm" className="btn btn-dim">
                                    View
                                  </Button>
                                </Link>
                              </div>
                              <Button className="btn-pd-auto d-sm-none">
                                <Icon name="chevron-right"></Icon>
                              </Button>
                            </DataTableRow>
                          </DataTableItem>
                        ))}
                      </div>
                    </Block>
                  </div>
                ))
              ) : (
                <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No products match your filters"} />
              )}

              {totalCategories > 0 && (
                <div className="mt-4">
                  <PaginationComponent
                    itemPerPage={itemPerPage}
                    totalItems={totalCategories}
                    paginate={paginate}
                    currentPage={currentPage}
                  />
                </div>
              )}
            </>
          ) : (
            <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Products Found"} />
          )}
        </Block>
      </Content>

      <AddProductModal
        isOpen={add_product_modal}
        tenant_info={tenant_info}
        closeModal={toggle_add_product}
        user_info={user_info}
        successFunction={retrieve_products}
      />
    </>
  );
};

export default ProductManagement;